import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { Button } from "../../globalStyles";
import "./newStyle.css";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavItemBtn,
  NavLinks,
  NavBtnLink,
} from "./Navbar.elements";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [data, setdata] = useState([]);
  const [data2, setdata2] = useState(null);
  const [footerdata, setfooterdata] = useState([]);
  const [hasBookLink, setHasBookLink] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  const GetImageData = async (orgId) => {
    const sendData2 = {
      OrgId: Number(orgId),
    };

    //console.log(sendData2);

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Main/GetOrganizationInfo`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        },
      );

      const data = await response.json();

      //console.log("Org: ", data);
      if (data.orgName) {
        document.title = data.orgName;
      }
      // Convert strings to booleans (supports array or object)

      setdata(data);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const GetImageData2 = async (orgId) => {
    const sendData2 = {
      OrgId: Number(orgId),
      ActiveStatus: "A",
      WebHeader: "Orgimage",
    };

    //console.log(sendData2);

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Main/GetmultipledataNew`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        },
      );

      const data = await response.json();

      //console.log("Image: ",data);
      // Convert strings to booleans (supports array or object)

      if (data[0].logoImage2) {
        const imgUrl = `https://mountsimageapi.azurewebsites.net/api/FileUpload/${data[0].logoImage2}`;
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          // Compress to 32x32 favicon size using canvas
          const canvas = document.createElement("canvas");
          canvas.width = 32;
          canvas.height = 32;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, 32, 32);
          const compressedUrl = canvas.toDataURL("image/png", 0.7);

          const link =
            document.querySelector("link[rel~='icon']") ||
            document.createElement("link");
          link.rel = "icon";
          link.href = compressedUrl;
          document.head.appendChild(link);
        };
        img.src = imgUrl;
      }

      setdata2(data[0]);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const Getfooterdata = async (orgId) => {
    const sendData2 = {
      OrgId: Number(orgId),
      ActiveStatus: "A",
      Type: "Zangie_DynamicWebsiteFooter",
    };

    //console.log(sendData2);

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Bill/Getwebsitedatadynamic`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        },
      );

      const data = await response.json();
      //console.log("Raw data:", data);
      setfooterdata(data);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const sendData2 = {
        ActualWebsite: window.location.hostname,
        //ActualWebsite: "ilcs.co.in",
        //ActualWebsite: "eh.mounts.in",
        //ActualWebsite: "healcop.com",
        OrgName: "test",
      };

      try {
        await fetch(
          `https://zaingielatestapi.azurewebsites.net/api/FLOW/Getorgiddynamic`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData2),
          },
        )
          .then((response) => response.json())
          .then((data) => {
            const orgid = data.orgId;
            GetImageData(orgid);
            GetImageData2(orgid);
            Getfooterdata(orgid);
            //Getfooterdata(2099)
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // ✅ CHECK IF BOOK LINK EXISTS
  useEffect(() => {
    const bookLinkExists = footerdata.some(
      (item) => item.lightTextDesc === "Top" && item.headline === "Book link",
    );
    setHasBookLink(bookLinkExists);
  }, [footerdata]);

  window.addEventListener("resize", showButton);

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav>
          <NavbarContainer>
            <NavLogo to="/" onClick={closeMobileMenu}>
              {data2?.logoImage2 ? (
                <img
                  style={{ maxWidth: 170, height: "90%" }}
                  alt="Logo"
                  src={`https://mountsimageapi.azurewebsites.net/api/FileUpload/${data2.logoImage2}`}
                />
              ) : (
                <div>Loading...</div> // Replace with a spinner if desired
              )}
            </NavLogo>
            <MobileIcon onClick={handleClick}>
              {click ? <FaTimes color="#101522" /> : <FaBars color="#101522" />}
            </MobileIcon>
            <NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLinks to="/" onClick={closeMobileMenu}>
                  Home
                </NavLinks>
              </NavItem>

              {footerdata.map((main, index) =>
                // ✅ SKIP "Book link" FROM REGULAR MENU
                main.lightTextDesc === "Top" &&
                main.headline !== "Book link" ? (
                  <NavItem key={index}>
                    <NavLinks
                      to={`dynamic?page=${encodeURIComponent(main.headline)}`}
                      onClick={closeMobileMenu}
                    >
                      {main.headline}
                    </NavLinks>
                  </NavItem>
                ) : null,
              )}

              <NavItem>
                <NavLinks to="/Contact" onClick={closeMobileMenu}>
                  Contact Us
                </NavLinks>
              </NavItem>
              <NavItemBtn>
                {button ? (
                  <NavLinks
                    onClick={() =>
                      window.location.replace("https://" + data.subDomainName)
                    }
                  >
                    Login
                  </NavLinks>
                ) : (
                  <NavBtnLink
                    onClick={() =>
                      window.location.replace("https://" + data.subDomainName)
                    }
                  >
                    <Button onClick={closeMobileMenu} fontBig primary>
                      Login
                    </Button>
                  </NavBtnLink>
                )}
              </NavItemBtn>
              {/* ✅ NEW BLINKING BOOK BUTTON - CENTER OF NAVBAR */}
              {hasBookLink && (
                <div className="book-button-container">
                  <a href="/booklinks" className="book-button blink-animation">
                    📚 Get Online Book
                  </a>

                  <a
                    href="/printBookRequest"
                    className="bookr-button blink-animation"
                  >
                    📚 Req. Print Book
                  </a>
                </div>
              )}
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;
